import firebase from '../../constants/firebase';

export const editLocation = (values) => {
    const db = firebase.firestore()
    const docId = values.uid
    const docRef = db.collection('locations').doc(docId)

    return docRef.update(values)
}